import { useLang } from "../../i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = [t("mq.1"), t("mq.2"), t("mq.3"), t("mq.4"), t("mq.5"), t("mq.6")];
  return (
    <section data-testid="editorial-marquee" className="bg-[#29221D] text-[#F3EFE6] py-8 overflow-hidden">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
            {items.map((it) => (
              <span key={it} className="font-serif italic text-4xl md:text-6xl px-10 flex items-center gap-10 whitespace-nowrap">
                {it}
                <span className="w-3 h-3 rounded-full bg-[#C18A53] inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
